import React, { useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { usePiers } from '../context/PiersContext';

const DateTabs = () => {
  const { availableDates, selectedDate, setSelectedDate } = usePiers();

  const handleChange = (event, newValue) => {
    setSelectedDate(availableDates[newValue]);
  };

  const rawIndex = availableDates.indexOf(selectedDate);
  const currentIndex = rawIndex >= 0 ? rawIndex : 0;

  useEffect(() => {
    if (availableDates.length > 0 && availableDates.indexOf(selectedDate) === -1) {
      setSelectedDate(availableDates[0]);
    }
  }, [availableDates, selectedDate, setSelectedDate]);

  if (availableDates.length === 0) {
    return null;
  }

  return (
    <Box sx={{ 
      borderBottom: 1, 
      borderColor: 'rgba(255, 255, 255, 0.1)',
      bgcolor: 'rgba(255, 255, 255, 0.02)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
    }}>
      <Tabs 
        value={currentIndex} 
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .MuiTabs-indicator': {
            backgroundColor: '#F9B612',
          },
          '& .MuiTab-root': {
            color: 'rgba(255, 255, 255, 0.5)',
            fontWeight: 500,
            fontSize: '0.875rem',
            textTransform: 'none',
            minWidth: 120,
            '&.Mui-selected': {
              color: '#F9B612',
            },
            '&:hover': {
              color: 'rgba(255, 255, 255, 0.8)',
              bgcolor: 'rgba(255, 255, 255, 0.05)',
            }
          },
          '& .MuiTabs-scrollButtons': {
            color: 'rgba(255, 255, 255, 0.5)',
            '&.Mui-disabled': {
              opacity: 0.3
            }
          }
        }}
      >
        {availableDates.map((date, index) => {
          // Format date for display
          const dateObj = new Date(date + 'T00:00:00');
          const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'short' });
          const monthDay = dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          
          return (
            <Tab 
              key={date} 
              label={
                <Box sx={{ textAlign: 'center' }}>
                  <Box sx={{ fontWeight: 600 }}>{dayName}</Box>
                  <Box sx={{ fontSize: '0.75rem', opacity: 0.8 }}>{monthDay}</Box>
                </Box>
              }
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

export default DateTabs;